import DOMPurify from 'dompurify';
import { SubHeader } from "../../subcomponents/subcomponents";
import Styles        from "./gemini.module.css";
import robotImg      from "../../images/Chat bot-bro.png";
import { gemini }    from "./gemini.api";
import { useEffect, useRef, useState } from "react";
import MarkdownIt from 'markdown-it';
//gemini container
export const GeminiContainer = ( props ) => {
    const { } = props;
    const { GeminiContainer } = Styles;
    const [ loading, setLoading ] = useState(false);
    const [ chats, setChats ] = useState([]);
    const onSubmit = (chatter, chat)=>{
        setChats(prev => [
            ...prev,
            {chatter: chatter,  chat: chat},   //user question
        ]);
        gemini(chat).then(response => { 
            setChats(prev => [
                ...prev,
                {chatter: "gemini", chat: response}//gemini response
            ]);
            setLoading(false);
        });
    };
    return (
        <div className={ GeminiContainer }>
            <GeminiChats   chats    = { chats }/>
            <GeminiChatBox loading = { loading } setLoading ={ setLoading } onSubmit = { onSubmit }/>
        </div>
    );
};
//gemini chat box
const GeminiChatBox          = ( props ) => {
    const { onSubmit, loading, setLoading } = props;
    const { GeminiChatBox } = Styles;
    return (
        <div className={ GeminiChatBox }>
            <ChatBoxInp loading = { loading } setLoading = { setLoading } onSubmit={ onSubmit }/>
        </div>
    );
};
//chat box input
const ChatBoxInp             = ( props ) => {
    const { onSubmit, loading, setLoading } = props;
    const { ChatBoxInp, GeminiLoader } = Styles;
    const inputElement = useRef(null);
    const [ placeholder, setPlaceholder ] = useState();
    const [ empty, setEmpty ] = useState(true);
    const [ value, setValue ] = useState(null);
    const placeholders = [
        "How can I help you? 🤔",
        "Hi, I am Gemini! ✨",
        "Need assistance in your project? 💡",
        "Need help in coding? 💻",
        "Looking for advice? 📘",
        "Need a quick solution? ⚡",
        "Stuck on a problem? 🧩",
        "Want to brainstorm ideas? 🧠",
        "How can I make your day better? 🌟",
        "Got a question? Ask me anything! ❓",
    ];
    useEffect(_=>{
        setPlaceholder(placeholders[Math.floor(Math.random() * placeholders.length)]);
    }, []);
    const onChange = ( event ) => {
        const { value } = event.target;
        const { style } = document.documentElement;
        if( value.length === 0 ){
            style.setProperty("--cursor", "default");
            style.setProperty("--empty", "0.2");
            setEmpty(true);
        }
        else{ 
            style.setProperty("--cursor", "pointer");
            style.setProperty("--empty", "1");
            setValue(value);
            setEmpty(false);
            setPlaceholder(placeholders[Math.floor(Math.random() * placeholders.length)]);
        }
    };
    const onSend = _=>{
        const { style } = document.documentElement;
        !empty && setLoading(true);
        !empty && onSubmit("user", value);
        inputElement.current.value = ""; 
        style.setProperty("--cursor", "default");
        style.setProperty("--empty", "0.2");
        setEmpty(true);
    };
    const onEnter = event =>{ 
        if( event.key === "Enter") onSend(); 
        else if(event.keyCode === 13) onSend(); 
    };
    return (
        <div className={ ChatBoxInp }>
            <i className="bi bi-chat-text-fill"></i>
            <input 
                ref         = { inputElement       }
                onKeyDown   = { e => onEnter( e )  }
                onChange    = { e => onChange( e ) }
                type        = {"text"              }
                placeholder = { placeholder        }
            />
            {
                loading ? <div className={ GeminiLoader }></div> : <i className="bi bi-send-fill" onClick={ onSend }></i>
            }
            
            
        </div>
    );
};
//gemini chats
const GeminiChats            = ( props ) => {
    const { chats = [] } = props;
    const { GeminiChats } = Styles;
    const [ scrollTop, setScrollTop ] = useState(false);
    const scroll = useRef(null);
    useEffect(_=>{
        scroll.current.scroll({
            top: scroll.current.scrollHeight,
            behavior: "smooth",
        });
    }, [chats]);

    const lastScrollTop = useRef(0); // Use `useRef` to keep track of the previous scroll position without causing re-renders.
    const handleScroll = (e) => {
        const currentScrollTop = Math.floor(e.target.scrollTop);
        if (currentScrollTop < lastScrollTop.current) {
            setScrollTop(true);
        }
        else if(currentScrollTop > lastScrollTop.current){
            setScrollTop(false);
        }

    lastScrollTop.current = currentScrollTop;
  };
    return (
        <div ref={ scroll } className={ GeminiChats } onScroll={ e => handleScroll( e ) }>
            { chats.length === 0 && <GeminiRobot /> }
            { 
                chats.map((value, key)=>{
                    const { chatter, chat } = value;
                    return (
                        chatter === "user" ? <Question chat = { chat } key = { key } /> : <Reply chat = { chat } key = { key } />
                    );
                })
            
            }
            { scrollTop && <ScrollBtn scrollElement = { scroll.current } /> }
        </div>
    );
};
const ScrollBtn              = ( props ) => {
    const { scrollElement } = props;
    const { ScrollBtn } = Styles;
    const scrollDown = _=>{
        scrollElement.scroll({
            top: scrollElement.scrollHeight,
            behavior: "smooth"
        });
    };
    return (
        <button className={ ScrollBtn } onClick={ scrollDown }>
            <i className="bi bi-arrow-down-circle-fill"></i>
        </button>
    );
};
//gemini welecoming
const GeminiRobot            = ( props ) => {
    const { } = props;
    const { GeminiRobot } = Styles;
    return (
        <div className={ GeminiRobot }>
            <img src={ robotImg } alt="gemini AI"/>
        </div>
    );    
};
//gemini replies
const Reply                  = ( props ) => {
    const { chat } = props;
    const { Reply } = Styles;
    const themes = ["#9c27b0", "#3f51b5", "#03a9f4", "#00bcd4", "#009688", "#8bc34a", "#cddc39", "#ff9800", "#ff5722", "#795548"];
    const [ theme, setTheme ] = useState();
    useEffect(_=>{
        setTheme(themes[Math.floor(Math.random() * themes.length)]);
    }, []);
    const md = new MarkdownIt();
    const sanitizedChat = DOMPurify.sanitize(md.render(chat));
    return (
        <div className={ Reply }>
            <SubHeader
                icon = { <i className="bi bi-stars"></i> }
                text = { "Gemini" }
            />
            <div style={{ color: theme }}>
                <div style={{ backgroundColor: theme }}></div>
                <main
                    dangerouslySetInnerHTML={{ __html: sanitizedChat }} // Convert HTML tags in `chat` to actual HTML elements
                />
            </div>
        </div>
    );
};
//user questions
const Question               = ( props ) => {
    const {chat } = props;
    const { Question } = Styles;
    const themes = ["#9c27b0", "#3f51b5", "#03a9f4", "#00bcd4", "#009688", "#8bc34a", "#cddc39", "#ff9800", "#ff5722", "#795548"];
    const [ theme, setTheme ] = useState();
    useEffect(_=>{
        setTheme(themes[Math.floor(Math.random() * themes.length)]);
    }, []);
    return (
        <div className={ Question }>
            <SubHeader
                icon = { <i className="bi bi-person-fill"></i> }
                text = { "You" }
            />
            <div style={{ color: theme }}>
                <div style={{ backgroundColor: theme }}></div>
                <main><bdi><pre><code>{ chat }</code></pre></bdi></main>
            </div>
        </div>
    );
};


